<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["options"],
  data() {
    return {
      htmlLegend: null,
      chartOptions: Object.assign(this.options, {
        legend: {
          ...this.options.legend,
          onClick: ((e, legendItem) => {
            if (legendItem.text === "Итого") return;

            var index = legendItem.datasetIndex;
            var ci = this.$data._chart;
            var meta = ci.getDatasetMeta(index);

            if (meta.hidden === null) {
              meta.hidden = true;
              ci.data.datasets[index].showLine = false;
            } else {
              meta.hidden = null;
              ci.data.datasets[index].showLine = true;
            }

            this.$emit("click-label", {
              e,
              legendItem,
              ci,
            });

            ci.update();
          }),
        },
      }),
    };
  },
  watch: {
    "$data._chart.data": {
      deep: true,
      handler(value) {
        this.htmlLegend = this.$data._chart.generateLegend();
        this.$emit("sendLegend", this.htmlLegend, this.$data._chart);
      },
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.chartOptions);
  },
};
</script>
